import React from 'react';
import classnames from 'classnames';
import shortenNumber from '../../../../../utils/shortenNumber';
import OverlayContext from '../OverlayContext';
import { useFlag } from '../../../../../redux/flags/hooks/useFlag';
import s from '../Overlay.scss';
var OverlayControl = function (_a) {
    var title = _a.title, stat = _a.stat, children = _a.children, className = _a.className, statClassName = _a.statClassName;
    var isV2 = useFlag('redesigned_mobile_browse');
    return (React.createElement(OverlayContext.Consumer, null, function (_a) {
        var _b = _a.showStats, showStats = _b === void 0 ? true : _b;
        return (React.createElement("div", { className: classnames(s['stat'], isV2 && s['statv2'], className) },
            showStats && (React.createElement("div", { className: classnames(s['stat-number'], statClassName), title: title }, shortenNumber(stat))),
            children));
    }));
};
OverlayControl.displayName = 'OverlayControl';
export default OverlayControl;
//# sourceMappingURL=OverlayControl.js.map